<template>
  <div class="game-container">
    <table>
      <tr v-for="(sample, index) in startData" :key="index">
        <td>
          <img :src="sample.img" />
        </td>
        <td>
          <tr-input
            class="game-input"
            :key="sample.id"
            :start-game-config="sample"
            :tr-input-value="initData[index]"
            :input-font-size="6"
          >
          </tr-input>
        </td>
        <td>
          <span>{{ initData[index].ans == 0 ? sample.type[0] : sample.type[1][0] }}</span>
        </td>
        <td>
          <tr-input
            v-if="initData[index].ans === 1 && sample.type[1].length == 2"
            class="game-input"
            :key="initData2[index].id"
            :start-game-config="sample"
            :tr-input-value="initData2[index]"
            :input-font-size="6"
          >
          </tr-input>
        </td>
        <td>
          <span v-if="initData[index].ans === 1 && sample.type[1].length == 2"> {{ sample.type[1][1] }} </span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import _ from 'lodash';
import TrInput from '../TrInput/TrInputV2';
export default {
  name: 'mp-compare-v2',
  components: { TrInput },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      initData: [],
      gameData: [],
    };
  },
  beforeMount() {
    this.newGame();
  },
  mounted() {},
  methods: {
    newGame() {
      this.initData = this.startGameConfig;

      this.initData2 = [];
      let items = this.shuffle(this.startGameConfig.sample.slice()).slice(0, this.startGameConfig.chooose);
      this.startData = Object.assign({}, this.shuffle(items));
      var bas = this.startGameConfig.sample2;
      var samp2 = [];
      this.initData = _.map(this.startData, (item) => {
        let ans = Math.round(Math.random());
        let str = item.id + 'b';
        let obj = {};
        if (ans == 1)
          bas.forEach(function (it, index) {
            if (it.id === str) {
              obj = _.clone(it);
              obj.val = '';
              obj.block = false;
              obj.inputStatus = null;
              return;
            }
          });
        samp2.push(obj);
        return { correct: item.correct, val: '', ans: ans, block: false, inputStatus: null };
      });
      this.initData2 = samp2;
    },
    shuffle(a) {
      if (a.length == 0) return;
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    resetGameAction() {
      this.newGame();
    },
    checkGameAction() {
      let isCorrect = true;
      // console.log(this.initData);
      // console.log(this.initData2);
      this.initData.forEach(function (item, index) {
        item.val = item.val.trim();
        if (
          !isNaN(parseFloat(item.val)) &&
          isFinite(item.val) &&
          ((item.ans == 0 && item.val == item.correct[0]) || (item.ans == 1 && item.val == item.correct[1][0]))
        ) {
          item.block = true;
          item.inputStatus = 'correct';
        } else {
          item.block = false;
          item.val = '';
          item.inputStatus = 'incorrect';
          isCorrect = false;
        }
      });
      this.initData2.forEach(function (item, index) {
        if ('val' in item) {
          item.val = item.val.trim();
          if (!isNaN(parseFloat(item.val)) && isFinite(item.val) && item.val == item.correct[1][1]) {
            item.block = true;
            item.inputStatus = 'correct';
          } else {
            item.block = false;
            item.val = '';
            item.inputStatus = 'incorrect';
            isCorrect = false;
          }
        }
      });
      return isCorrect;
    },
  },
  computed: {
    checkGame() {
      return this.$store.getters.checkGame;
    },
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    checkGame: function (newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      // // console.log('newStatus', newStatus);
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.game-container {
  display: flex;
  padding-top: 200px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.game-container img {
  max-width: 1000px;
}
.game-container td {
  padding: 20px;
}
.game-input {
  max-width: 150px;
}
</style>
